// extracted by mini-css-extract-plugin
export default {"header":"style_header__fwwLR","side":"style_side__FiRnS"};